import React, { createContext, useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
// import Records from "./pages/records/Records";
import MemoizedTransactions from "./pages/Transactions/Transactions";
import SideDrawer from "./components/SideDrawer";
import NotFound404ValidUser from "./components/NotFound404ValidUser";
import "./styles/app.scss";
import Settings from "./pages/Settings/Settings";
import LoginPage from "./pages/LoginPage";
import Profile from "./pages/Profile/Profile";
import Usage from "./pages/Usage/Usage";
import ContactSupport from "./pages/ContactSupport/ContactSupport";
import axios from "axios";
import { decryptText } from "./utils/cipherText";
import ConfirmPassword from "./pages/ConfirmPassword/ConfirmPassword";
import GstItr from "./pages/GST-ITR/GstItr";
import LoanAction from "./pages/LoanAction/LoanAction";
import KycStatus from "./pages/KYC/KycStatus";
import KycUserPage from "./pages/KYC/KycUserPage";
import IndividualDetails from "./pages/KYC/IndividualDetails";
import Individuals from "./pages/Individuals/Individuals";
import Notification from "./pages/Notification/Notification";
import LoanActionRevoke from "./pages/LoanAction/LoanActionRevoke";
import Consolidated from "./pages/Consolidated/Consolidated";
import EligibleUsers from "./pages/EligibleUsers/EligibleUsers";
import LtvConfiguration from "./pages/Settings/Configurations/LtvConfiguration";
import Stocks from "./pages/Stocks/Stocks";
import NewDistributors from "./pages/distributors/NewDistributors";
import Odtransactions from "./pages/OdTransactions/Odtransactions";
import EligibleUsersView from "./pages/EligibleUsers/EligibleUsersView";

export const sideBarContext = createContext();
function App() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [url, setUrl] = useState(window.location.pathname);
  const [expanded, setExpanded] = useState(false);
  const config = {
    headers: { Authorization: `${token}` },
  };
  let location = useLocation();

  const testToken = async () => {
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    try {
      await axios.request(
        `${process.env.REACT_APP_URL}/lender/profile`,
        options
      );
    } catch (error) {
      if (
        error.response.status === 401 &&
        error.response.data.message === "Session Expired. Please Login."
      ) {
        localStorage.removeItem("token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    testToken();
    if (location.pathname === "/" && token) {
      if (userType === "distributors") {
        navigate("/kyc");
      } else {
        navigate("/dashboard");
      }
    }
  }, [Navigate, url]);

  let NavArr = [
    "/dashboard",
    "/employees",
    "/kyc",
    "/earnings",
    "/settings",
    "/profile",
  ];
  let currentPath = location.pathname;
  let showPath = NavArr.find((path) => currentPath === path);

  return (
    <>
      <sideBarContext.Provider value={{ expanded, setExpanded }}>
        <Routes>
          <Route exact path="/" element={<LoginPage />} />
          <Route
            exact
            path="/confirm-password/:id"
            element={<ConfirmPassword />}
          />

          {userType !== "distributors" && (
            <Route
              path="/dashboard"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <Dashboard />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {userType !== "distributors" && (
            <Route
              path="/consolidated"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <Consolidated />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {/* <Route
            path="/workspace"
            element={token !== null ? <Workspace /> : <Navigate replace to="/" />}
          /> */}
          {/* <Route
          path="/users"
          element={
            token !== null ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <SideDrawer />
                <Users />
              </div>
            ) : (
              <Navigate replace to="/" />
            )
          }
        /> */}
          {/* <Route
            path="/employees"
            element={token !== null ? <Employees /> : <Navigate replace to="/" />}
          /> */}
          {/* <Route
          path="/users"
          element={
            token !== null ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <SideDrawer />
                <Users />
              </div>
            ) : (
              <Navigate replace to="/" />
            )
          }
        /> */}
          <Route
            path="/kyc"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <KycStatus />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          {userType !== "distributors" && (
            <Route
              path="/eligibleusers"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <EligibleUsers />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {userType !== "distributors" && (
            <Route
              path="/eligibleusers/:id"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <EligibleUsersView />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}

          <Route
            path="/assets"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <Individuals />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/transactions"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <MemoizedTransactions />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/od_transactions"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <Odtransactions />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          {userType !== "distributors" && (
            <Route
              path="/distributors"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <NewDistributors />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {userType !== "distributors" && (
            <Route
              path="/invoke"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <LoanAction />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {userType !== "distributors" && (
            <Route
              path="/revoke"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <LoanActionRevoke />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {userType !== "distributors" && (
            <Route
              path="/notification"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <Notification />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {/* <Route
          path="/userpage/:id"
          element={
            token !== null ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <SideDrawer />
                <UserPage />
              </div>
            ) : (
              <Navigate replace to="/" />
            )
          }
        /> */}
          <Route
            path="/kyc/:id"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <KycUserPage />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          {userType !== "distributors" && (
            <Route
              path="/individuals/:id"
              element={
                token !== null && userType !== "distributors" ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <IndividualDetails />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}

          <Route
            path="/kyc/:id"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <KycUserPage />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />

          {/* <Route
          path="/individuals/:id/stocks"
          element={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <SideDrawer />
              <Stocks />
            </div>
          }
        /> */}

          {userType === "admin" && (
            <Route
              path="/settings"
              element={
                token !== null && userType === "admin" ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <Settings />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          <Route
            path="/ltv"
            element={
              token !== null && userType === "admin" ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <LtvConfiguration />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          <Route
            path="/profile"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <Profile />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
          {userType !== "distributors" && (
            <Route
              path="/usage"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <Usage />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {/* {userType === "distributors" ? null : localStorage.getItem(
            "lender_id"
          ) === "7" ? null : (
          <Route
            path="/mca"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <MCA />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
        )} */}
          {userType === "distributors" ? null : localStorage.getItem(
              "lender_id"
            ) === "7" ? null : (
            <Route
              path="/gst"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <GstItr />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          {userType === "distributors" ? null : localStorage.getItem(
              "lender_id"
            ) === "7" ? null : (
            <Route
              path="/itr"
              element={
                token !== null ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <SideDrawer />
                    <GstItr />
                  </div>
                ) : (
                  <Navigate replace to="/" />
                )
              }
            />
          )}
          <Route
            path="/support"
            element={
              token !== null ? <ContactSupport /> : <Navigate replace to="/" />
            }
          />
          <Route
            path="*"
            element={
              token !== null ? (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <SideDrawer />
                  <NotFound404ValidUser />
                </div>
              ) : (
                <Navigate replace to="/" />
              )
            }
          />
        </Routes>
      </sideBarContext.Provider>
    </>
  );
  // }
}

export default App;
